import { PopoutAccountOptions } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutAccountOptions/PopoutAccountOptions";
import { PopoutUserInformation } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutUserInformation/PopoutUserInformation";
import { popoutContainerCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/UserProfilePopout.styles";

const UserProfilePopout = () => {
  return (
    <div css={popoutContainerCss} data-testid="user-profile-popout">
      <PopoutUserInformation />
      <PopoutAccountOptions />
    </div>
  );
};

UserProfilePopout.displayName = "UserProfilePopout";
export { UserProfilePopout };
